import CaseDetails from "@/components/New/Cases/CaseDetails.vue"
import { FieldDataTypes, FieldTypeId } from "@/types/fieldTypes"

export interface TimeManagementWeeklyReportPresetCaseResult extends CaseDetails {
	user: string
	role: string
	totalTimeManagementHoursForUser: number
	timeSpentHoursForUserOnWeekdays: number[]
	totalTimeSpentHoursForUser: number
	timeManagementHoursTimeSpentPercentIncrease: number
	totalUserShiftsInWeek: number
	totalUserShiftHoursInWeek: number
	userShiftsWorkedInWeek: string,
	userDaysWorkedInWeek: string,
	hoursWorkedMonday: number
	hoursWorkedTuesday: number
	hoursWorkedWednesday: number
	hoursWorkedThursday: number
	hoursWorkedFriday: number
	hoursWorkedSaturday: number
	hoursWorkedSunday: number
}

export const userDetailsColumns = [
	{
		key: "user",
		label: "User",
		dataType: FieldTypeId.User
	},
	{
		key: "role",
		label: "Role",
		dataType: FieldTypeId.Text
	}
]

export const getTimeBreakdownColumns = (startDayOfWeek: number) => ([
	{
		key: "totalTimeManagementHoursForUser",
		label: "Total Schedule Management Hours",
		dataType: FieldDataTypes.Number
	},
	...getWeekdayColumns(startDayOfWeek),
	{
		key: "totalTimeSpentHoursForUser",
		label: "Total Hours Spent",
		dataType: FieldDataTypes.Number
	},
	{
		key: "timeManagementHoursTimeSpentPercentIncrease",
		label: "Time Spent Above Assigned (%)",
		dataType: FieldDataTypes.Number
	}
])

const getWeekdayColumns = (startDayOfWeek: number) => {
	const dayColumns = [
		{
			key: "hoursWorkedSunday",
			label: "Sunday",
			dataType: FieldDataTypes.Number
		},
		{
			key: "hoursWorkedMonday",
			label: "Monday",
			dataType: FieldDataTypes.Number
		},
		{
			key: "hoursWorkedTuesday",
			label: "Tuesday",
			dataType: FieldDataTypes.Number
		},
		{
			key: "hoursWorkedWednesday",
			label: "Wednesday",
			dataType: FieldDataTypes.Number
		},
		{
			key: "hoursWorkedThursday",
			label: "Thursday",
			dataType: FieldDataTypes.Number
		},
		{
			key: "hoursWorkedFriday",
			label: "Friday",
			dataType: FieldDataTypes.Number
		},
		{
			key: "hoursWorkedSaturday",
			label: "Saturday",
			dataType: FieldDataTypes.Number
		}
	]

	// Wrap around the columns based on the start day of the week
	return [...dayColumns.slice(startDayOfWeek), ...dayColumns.slice(0, startDayOfWeek)]
}

export const userShiftSummaryColumns = [
	{
		key: "totalUserShiftsInWeek",
		label: "Total User Shifts In Week",
		dataType: FieldTypeId.Number
	},
	{
		key: "totalUserShiftHoursInWeek",
		label: "Total User Shift Hours In Week",
		dataType: FieldTypeId.Number
	},
	{
		key: "userShiftsWorkedInWeek",
		label: "User Shifts Worked In Week",
		dataType: FieldTypeId.Text
	},
	{
		key: "userDaysWorkedInWeek",
		label: "User Days Worked In Week",
		dataType: FieldTypeId.Text
	}
]
